<template>
  <b-container fluid>
    <b-container fluid v-if="!loading">
      <div class="modal-spinner">
        <b-spinner variant="secondary" label="Loading..."></b-spinner>
        <strong class="mt-3">Загрузка...</strong>
      </div>
    </b-container>
    <b-form @submit.stop.prevent="onSubmit" v-else>
      <b-row class="mx-3">
        <!--<b-col lg="4">-->
        <!--<div class="picture-container">-->
        <!--<img src="../../../public/images.png" class="mt-3" height="200" width="200"/>-->
        <!--<h6 class="mt-2">Выберите фото</h6>-->
        <!--</div>-->
        <!--</b-col>-->
        <b-col lg="6">
          <b-form-group
            label="Имя *"
            label-for="firstName"
            label-class="mf-label"
            :invalid-feedback="getError('firstName')"
            :state="validateState('firstName')"
          >
            <b-input-group class="mt-3">
              <b-input-group-text slot="prepend"><i class="fas fa-user"></i></b-input-group-text>
              <b-form-input name="firstName"
                            id="firstName"
                            placeholder="Имя (обязательное)"
                            v-model="model.first_name"
                            v-validate="modelValidations.firstName"
                            :state="validateState('firstName')"
                            data-vv-as="имя"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group
            label="Фамилия *"
            label-for="lastName"
            label-class="mf-label"
            :invalid-feedback="getError('lastName')"
            :state="validateState('lastName')"
          >
            <b-input-group class="mt-3">
              <b-input-group-text slot="prepend"><i class="fas fa-user"></i></b-input-group-text>
              <b-form-input name="lastName"
                            id="lastName"
                            placeholder="Фамилия (обязательное)"
                            v-model="model.last_name"
                            v-validate="modelValidations.lastName"
                            :state="validateState('lastName')"
                            data-vv-as="фамилия"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mx-3">
        <b-col lg="6">
          <b-form-group
            label="Отчество"
            label-for="middleName"
            label-class="mf-label"
            :invalid-feedback="getError('middleName')"
            :state="validateState('middleName')"
          >
            <b-input-group class="mt-3">
              <b-input-group-text slot="prepend"><i class="fas fa-user"></i></b-input-group-text>
              <b-form-input name="middleName"
                            id="middleName"
                            placeholder="Отчество"
                            v-model="model.middle_name"
                            v-validate="modelValidations.middleName"
                            :state="validateState('middleName')"
                            data-vv-as="отчество"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mx-3">
        <b-col lg="6">
          <b-form-group
            label="Email"
            label-for="email"
            label-class="mf-label"
            :invalid-feedback="getError('email')"
            :state="validateState('email')"
          >
            <b-input-group class="mt-3">
              <b-input-group-text slot="prepend"><i class="fas fa-at"></i></b-input-group-text>
              <b-form-input name="email"
                            id="email"
                            placeholder="Email (обязательное)"
                            v-model="model.email"
                            v-validate="modelValidations.email"
                            :state="validateState('email')"
                            aria-describedby="email-feedback"
                            data-vv-as="email"
                            disabled
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group
            label="Телефон *"
            label-for="mobile"
            label-class="mf-label"
            :invalid-feedback="getError('mobile')"
            :state="validateState('mobile')"
          >
            <b-input-group class="mt-3">
              <b-input-group-text slot="prepend"><i class="fas fa-phone"></i></b-input-group-text>
              <b-form-input name="mobile"
                            id="mobile"
                            placeholder="Ваш телефон"
                            v-model="model.phone"
                            v-validate="modelValidations.phone"
                            :state="validateState('mobile')"
                            data-vv-as="телефон"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="12" class="mt-5">
          <b-button type="submit" :disabled="veeErrors.any()" variant="success">Редактировать</b-button>
        </b-col>
      </b-row>

    </b-form>
  </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UserProfile',
  data () {
    return {
      loading: null,
      model: {
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        phone: ''
      },
      modelValidations: {
        firstName: {
          required: true,
          alpha: true
        },
        lastName: {
          required: true,
          alpha: true
        },
        middleName: {
          alpha: true
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          regex: /^((\+7|7|8)+([0-9]){10})$/
        }
      }
    }
  },
  watch: {
    userProfile () {
      this.model.first_name = this.userProfile.user_profile.first_name
      this.model.last_name = this.userProfile.user_profile.last_name
      this.model.phone = this.userProfile.user_profile.phone
      this.model.email = this.userProfile.email
      this.loading = true
    }
  },
  computed: {
    ...mapState(
      {
        userProfile: state => state.addUserData.userProfile
      }
    )
  },
  mounted () {
    this.$store.dispatch('showUserInfo').then(
      () => this.getUserData()
    )
  },
  methods: {
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        const userProfile = {
          email: this.model.email,
          user_profile: this.model
        }
        this.editUserData(userProfile)
          .then(response => {
            console.log(response)
            this.$bvModal.msgBoxOk('Ваши данные успешно изменены!', {
              title: 'Данные изменены',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          })
          .catch(error => {
            console.log(error)
            this.$bvModal.msgBoxOk('Что-то пошло не так!', {
              title: 'Что-то пошло не так',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
          })
      })
    },
    ...mapActions('addUserData',
      [
        'getUserData',
        'editUserData'
      ]
    )
  }
}
</script>

<style scoped>

</style>
